import React from 'react';

const Community: React.FC = () => {
  const communityRoles = [
    {
      title: 'Docker Captain',
      description: 'Member of the Docker Captains program, recognized for expertise and contributions to the Docker community.',
      link: 'https://www.docker.com/community/captains/'
    },
    {
      title: 'CD Foundation Ambassador',
      description: 'Ambassador for Continuous Delivery Foundation, promoting best practices in CI/CD.',
      link: 'https://cd.foundation/ambassador-program/'
    },
    {
      title: 'DevOps Institute Ambassador',
      description: 'Representing DevOps Institute, advocating for DevOps culture and practices.',
      link: 'https://www.devopsinstitute.com/ambassadors/'
    },
    {
      title: '(Not Active) AWS Community Builder',
      description: 'Former member of AWS Community Builders program, sharing knowledge and experience in cloud technologies.',
      link: 'https://aws.amazon.com/developer/community/community-builders/'
    },
  ];

  return (
    <div className="page community">
      <div className="container">
        <section className="hero-section">
          <img 
            src="/images/54123292160_f05881b70c_o.jpg" 
            alt="Pawel Piwosz Community" 
            className="community-hero-image" 
          />
          <h1>Community Involvement</h1>
        </section>
        
        <div className="intro-text">
          <p>Actively contributing to and representing major technology communities.</p>
        </div>

        <div className="community-grid">
          {communityRoles.map((role) => (
            <div key={role.title} className="community-card">
              <h2>{role.title}</h2>
              <p>{role.description}</p>
              <a href={role.link} target="_blank" rel="noopener noreferrer">
                Learn More
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Community;